export default __webpack_public_path__ + "static/media/BNB.797868eb.svg";